import React from "react";
import classNames from "classnames";

interface IconProps {
    name: string;
    filled?: boolean;
    className?: string;
}

export const Icon = ({
    name,
    filled = false,
    className,
}: IconProps): React.JSX.Element => {
    const iconClasses = classNames("material-symbols-outlined", className);
    return (
        <span
            aria-hidden="true"
            className={iconClasses}
            style={
                filled ? { fontVariationSettings: "'FILL' 1" } : undefined
            }
        >
            {name}
        </span>
    );
};
